import { o_util } from "../../common/namespaces";
import { assignNamespace } from "../../common/assignNamespace.js";
import { delegate, undelegate } from "./head/delegate.js";
import { stop } from "./head/event.js";
import { whichTransitionEndEvent } from "./head/legacy.js";
import { on, withEvents } from "./head/event.js";
import { unsetAll } from "./head/unset.js";

assignNamespace(
  o_util,
  "event",
  {
    delegate,
    undelegate,
    stop,
    on,
    withEvents,
    unsetAll,
  },
  { whichTransitionEndEvent },
);
